import React, { useState, useEffect } from "react";
import DropdownRight from "./DropdownRight";
import Nav from "../components/Nav";
import dots from "../assets/images/dots.svg";
import http from "../services/http";
import polygon from "../assets/images/Polygon 56.png";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { SpinnerCircular } from "spinners-react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import Filter from "./Filter";

import { Table } from 'antd';
const RawVideo = () => {
  const token = localStorage.getItem("xAuthToken");
  const [rawVideo, setrawVideo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShow] = useState(false);
  const [showModals, setShows] = useState(false);

  const [selectedId, setSelectedId] = useState(0);
  const [message, setMessage] = useState("");
  const [inputText, setInputText] = useState("");
  const [zipText, setZipText] = useState("");
  const [value, setValues] = useState("0");
  const [url, setUrl] = useState("");
  const [categories, setCategories] = useState([]);
  const [category_id, setCategoryId] = useState();
  const [localSpin, setLocalSpin] = useState(false);
  const [uploadSpin, setUploadSpin] = useState(false);
  const [deleteSpin, setDeleteSpin] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const navigate = useNavigate();

  const handleCloses = () => {
    setShows(false);
    setError("");
  };
  const handleShow = (id) => {
    setSelectedId(id);
    setShow(true);
  };

  const selectCategory = (e) => {
    setCategoryId(e.target.value);
  };

  const handleShows = (id) => {
    setLoading(true);
    http.get(`api/common/categories?token=${token}`).then((res) => {
      setCategories(res.data);
      setLoading(false);
    });
    setShows(true);
  };
  useEffect(() => {
    RawVideos();
  }, []);

  const columns = [
    {
      title: 'Team',
      dataIndex: 'team',
      sorter: (a, b) => {
        if (a.team < b.team) {
          return -1;
        }
        if (a.team > b.team) {
          return 1;
        }
        return 0;
        //a.team.length - b.team.length
      },
      ellipsis: true,
    },
    {
      title: 'Cam 1',
      dataIndex: 'outputFilenameCam1',
      key: 'name',
      render: (_, record) => (
        <Link
          to="/video"
          state={{
            name: record.outputFilenameCam1,
            id: record.id
          }}
        // onClick={() =>
        //   WatchVideoCode(record.id, "recording")} 
        >
          {" "}
          {record.outputFilenameCam1
            .split("/")
          [
            record.outputFilenameCam1.split("/").length - 1
          ].toUpperCase()}

        </Link>

      ),
    },
    {
      title: 'Cam 2',
      dataIndex: 'outputFilenameCam2',
      key: 'name',
      render: (_, record) => (
        <Link
          to="/video"
          state={{
            name: record.outputFilenameCam2,
            id: record.id
          }}
        // onClick={() =>
        //   WatchVideoCode(record.id, "recording")} 
        >
          {" "}
          {record.outputFilenameCam2
            .split("/")
          [
            record.outputFilenameCam2.split("/").length - 1
          ].toUpperCase()}

        </Link>

      ),
    },
    {
      title: 'Swimmer',
      dataIndex: 'swimmer',
      render: (_, record) => (

        <div>
          {record.firstname}{" "}{record.lastname}
        </div>




      ),
    },
    {
      title: 'Stroke Type',
      dataIndex: 'stroke',
      sorter: (a, b) => a.stroke - b.stroke,
    },
    {
      title: 'Group',
      dataIndex: 'groupName',
      sorter: (a, b) => a.groupName - b.groupName,
    },
    {
      title: 'Date Filmed',
      dataIndex: 'timestamp',
      render: (_, record) => (

        <div> {" "}

          {moment(record.timestamp).format("MMM Do YY")}
        </div>
      ),

    },


  ];

  const handleChanges = (event) => {
    const val = event.target.files[0];
    setValues(val);
  };

  const handleUpload = () => {
    if (inputText === "") {
      setError("File name is required.");
      return;
    } else if (!category_id) {
      setError("Category is required.");
      return;
    }
    if (value.type !== "video/mp4") {
      setError("Invalid file.");
      return;
    } else {
      setError("");
    }
    setUploadSpin(true);
    http
      .post(`api/admin/videos/s3video?token=${token}`, {
        file_type: "video/mp4",
        file_name: inputText,
        category_id,
        zip: zipText,
      })
      .then((res) => {
        setUploadSpin(false);
        const { url, key } = res.data;
        setUrl(key);
        setLocalSpin(true);
        fetch(url, {
          body: value,
          method: "PUT",
          headers: {
            "content-type": value.type,
            Accept: "*/*",
            "Content-Disposition": "attachment",
          },
        }).then((res) => {
          setLocalSpin(false);
          RawVideos();
        });
        setCategoryId();
        setInputText("");

        handleCloses();
      })
      .catch((error) => {
        setUploadSpin(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  const RawVideos = async (params) => {
    setLoading(true);
    let url = `api/admin/filterrecording?token=${token}`;
    if (params) {
      url = url + `${params}`
    }
    http
      .get(url)
      .then((res) => {
        setLoading(false);

        setrawVideo(res.data);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
    // http
    //   .get(`api/admin/videos?token=${token}`)
    //   .then((res) => {
    //     setLoading(false);

    //     setrawVideo(res.data);
    //   })
    //   .catch((error) => {
    //     setLoading(false);
    //     if (error.response) {
    //       if (error.response.data.errors) {
    //         for (let key in error.response.data.errors) {
    //           setError(error.response.data.errors[key]);
    //         }
    //       } else if (error.response.data.message) {
    //         setError(error.response.data.message);
    //       }
    //     }
    //   });
  };

  const DeleteVideo = async () => {
    setDeleteSpin(true);

    http
      .delete(`/api/admin/videos/${selectedId}?token=${token}`)
      .then((res) => {
        setrawVideo(rawVideo.filter((element) => element.id !== selectedId));

        handleClose();
        setDeleteSpin(false);
      })
      .catch((error) => {
        setDeleteSpin(false);
      });
  };

  const onFilterApply = (filterObject) => {
    const keys = Object.keys(filterObject);
    let params = undefined;

    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];
      if (filterObject[key] != null && filterObject[key]) {
        if (params) {
          params = params + `&${key}=${filterObject[key]}`;
        } else {
          params = `&${key}=${filterObject[key]}`;
        }
      }
    }
    RawVideos(params)

  }

  const WatchVideoEvo = async (id, type) => {
    setLoading(true);

    http
      .get(`api/common/video_request?token=${token}`)
      .then((res) => {
        console.log("response ------->>>>", res.data);

        navigate(`/otpLogs/${id}/${type}`);

        // setLocker(res.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <>
      <div class="wrapper">
        <Nav />
        <div id="content">
          <header>
            <div class="dashboard_header">
              <div class="left-side d-flex ">
                {" "}
                <button
                  type="button"
                  id="sidebarCollapse"
                  class="btn btn-link bt_none"
                >
                  <i class="fa fa-align-left"></i>{" "}
                </button>
                <h1>Raw Video</h1>
              </div>
              <div class="user_profile   ">
                <DropdownRight />
              </div>
            </div>
          </header>
          <div class="dashbord_content">
            <div class="analysts-wraper-head">
              <div class="form-group search_wraper">
                <Filter onFilterApply={onFilterApply}></Filter>
              </div>
              <div class="map_btn" style={{ marginBottom: 30 }}>
                {" "}
                <button
                  class="them_btn"
                  type="button"
                  data-toggle="modal"
                  data-target="#Google_Meet"
                  onClick={handleShows}
                >
                  Upload New Raw Video
                </button>{" "}
              </div>
            </div>
            <div class="table_vedio_upload dashbord_table    team_table mb_30 over_flow mb-0">
              {/* <table class="table table-borderless table-responsive-md">
                <thead>
                  <tr>
                    <th scope="col" class="  pl_25">
                      Video
                    </th>
                    <th scope="col" class=" ">
                      File Name
                    </th>
                    <th scope="col" class=" text-center">
                      actions
                    </th>
                  </tr>
                </thead>
                <tbody> */}
              {loading ? (
                <div
                  style={{
                    position: "absolute",
                    marginTop: 250,
                    // backgroundColor: "#ffffffc2",
                    marginLeft: 580,

                    // backgroundBlendMode: "overlay",
                    zIndex: 100,
                  }}
                >
                  <SpinnerCircular size="15%" />
                </div>
              ) : (
                ""
              )}
              {
                <Table className='custom-css-table desktop_show' columns={columns} dataSource={rawVideo}></Table>

                // rawVideo?.map((item) => (
                //   <tr>
                //     <td>
                //       <div style={{ marginTop: 10 }}>
                //         <Link
                //           style={{
                //             position: "relative",
                //           }}
                //           to="/video"
                //           state={{
                //             name: item.outputFilenameCam1,
                //             id: item.id
                //           }}
                //         >
                //           <video
                //             style={{ objectFit: "cover" }}
                //             width={130}
                //             height={70}
                //             src={item.outputFilenameCam1}
                //           ></video>
                //           <img
                //             src={polygon}
                //             alt=""
                //             style={{
                //               position: "absolute",
                //               marginTop: 25,
                //               marginLeft: -70,
                //               width: 20,
                //               height: 20,
                //             }}
                //           />
                //         </Link>
                //       </div>
                //     </td>

                //     <td>{item.outputFilenameCam1.toUpperCase()}</td>
                //     <td>
                //       <div className="dropdown wraper_btn">
                //         <Dropdown>
                //           <Dropdown.Toggle
                //             className="btn dropdown-toggle"
                //             variant="success"
                //             id="dropdown-basic"
                //           >
                //             <img src={dots} className="img-fulid  " />
                //             <span className="caret"></span>
                //           </Dropdown.Toggle>

                //           <Dropdown.Menu as="ul" className="dropul">
                //             <Dropdown.Item
                //               as="li"
                //               onClick={() => handleShow(item.id)}
                //             >
                //               Delete Video
                //             </Dropdown.Item>
                //           </Dropdown.Menu>
                //         </Dropdown>
                //       </div>
                //     </td>
                //   </tr>
                // ))
              }
              {localSpin ? (
                <tr>
                  <td>
                    {" "}
                    <SpinnerCircular size="15%" />
                  </td>
                  <td>Uploading video</td>
                  <td></td>
                </tr>
              ) : (
                ""
              )}
              {/* </tbody>
              </table> */}
            </div>
          </div>
        </div>
      </div>

      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title as="h5">Are you sure?</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div class="raing_star">
            <p>Are you sure you want to delete.</p>
          </div>
          <div className="modal-footer border-top-0">
            <button
              onClick={handleClose}
              type="button"
              className=" them_btn_ouline  "
            >
              Cancel
            </button>
            <button
              onClick={DeleteVideo}
              type="button"
              className="them_btn1 "
              data-toggle="modal"
              data-target="#new_team_add_yes"
            >
              {deleteSpin ? <SpinnerCircular /> : " Confirm"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="starrating" show={showModals} onHide={handleCloses}>
        <Modal.Header>
          <Modal.Title as="h5">Upload new raw video</Modal.Title>
          <button
            onClick={handleCloses}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <input
            className="custom_input w-100 form-control"
            onChange={(e) => {
              setInputText(e.target.value);
            }}
            placeholder="Enter Text"
          />

          {loading ? (
            <div
              style={{
                marginLeft: 120,
                backgroundBlendMode: "overlay",
                zIndex: 10,
              }}
            >
              <SpinnerCircular size="10%" />{" "}
            </div>
          ) : (
            <>
              <select
                name="category_id"
                onChange={selectCategory}
                className="custom_input w-100 form-control"
              >
                {categories.map((item) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </select>
            </>
          )}
          <input
            className="custom_input w-100 form-control"
            onChange={(e) => {
              setZipText(e.target.value);
            }}
            placeholder="zip file link"
          />
          <input
            type="file"
            className="custom_input w-100 form-control"
            name="myfile"
            onChange={handleChanges}
          />

          <div className="modal-footer border-top-0">
            <button
              type="button"
              className="them_btn_ouline "
              onClick={handleCloses}
            >
              Cancel
            </button>
            <button
              type="button"
              className="them_btn1 "
              onClick={handleUpload}
              disabled={uploadSpin ? true : false}
            >
              {uploadSpin ? <SpinnerCircular /> : " Upload Video"}
            </button>
          </div>
          <h5 style={{ color: "green" }}>{message}</h5>
          <h5 style={{ color: "red" }}>{error}</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RawVideo;
